import React from 'react'
import PropTypes from 'prop-types'
import styles from './button.module.scss'

export const Button = ({ onClick, text }) => {
  return (
    <div className={styles.buttonContainer}>
      <button onClick={onClick}>{text}</button>
    </div>
  )
}

Button.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string
}
